import styled from "styled-components";
import { useEffect, useState } from "react";
import { ReactComponent as Send } from "../../../assets/img/icons/SendingWhite.svg";
import { ReactComponent as Eye } from "../../../assets/img/icons/eye.svg";
import { ReactComponent as Elipsis } from "../../../assets/img/icons/ArticlePopover/Elipsis.svg";
import { ReactComponent as Mail } from "../../../assets/img/icons/mail.svg";
import { ReactComponent as Audience } from "../../../assets/img/icons/Audience.svg";
import { ReactComponent as Click } from "../../../assets/img/icons/Click.svg";
// import { ReactComponent as Clock } from "../../../assets/img/icons/Clock.svg";
import { ReactComponent as Tiles } from "../../../assets/img/icons/Tiles.svg";
import { ReactComponent as Portal } from "../../../assets/img/icons/Portal.svg";
import { ReactComponent as CampaignIcon } from "../../../assets/img/icons/Campaign/AllCampaign.svg";
// import { ReactComponent as Workflow } from "../../../assets/img/icons/Campaign/workflow.svg";
import Workflow from "../../../assets/img/icons/Campaign/workflow.svg";
// import ShareMenuPopup from "../../Common/Components/ShareMenuPopup";
import MenuPopup from "modules/Common/Components/MenuPopup";
import { Tooltip, Typography } from "antd";
import store from "store";
import { CAMPAIGNS_LIST, GET_CAMPAIGNS_NAMES_ONLY } from "constants/types";
import { cloneCampaignService } from "modules/Services/CampaignsService";
import { createNewCampaignSerialize } from "../utils";

interface ICampaignCardProps {
  campaignId?: string;
  deleteHandler?(index: any, campaignId: string, assetId: number): void;
  index?: number;
  title?: string;
  imgUrlOne?: string;
  imgUrlTwo?: string;
  imgUrlThree?: string;
  type?: string;
  published?: string;
  emailsCount?: number;
  time?: string;
  grid?: boolean;
  portal?: boolean;
  email?: boolean;
  audience?: string;
  campaign?: boolean;
  send?: string;
  mail?: string;
  views?: string;
  clicks?: string;
  onCardClick?: () => void;
  wrapperClass?: string;
  showDeleteConfirmation?: () => void;
  automation?: boolean;
}

const CampaignCard: React.FC<ICampaignCardProps> = (props) => {
  const [ellipsisState, setEllipsistate] = useState(false);
  // const [campTitle, setCampTitle] = useState("");
  const { Paragraph } = Typography;

  // useEffect(() => {
  //   if (props?.title && props.title.startsWith("[Cloned]")) {
  //     const titleText = props?.title?.substring(8);
  //     setCampTitle(titleText);
  //   }
  // }, [props.title]);

  const cloneCampaignHandler = (hide: () => void) => {
    store.dispatch({
      type: CAMPAIGNS_LIST.CLONE_IN_PROGRESS,
      payload: true,
    });
    props.campaignId &&
      cloneCampaignService(parseInt(props.campaignId))
        .then((res) => {
          const data = res.data;
          const campId = props.campaignId;
          if (data.success) {
            store.dispatch({
              type: CAMPAIGNS_LIST.CLONE,
              payload: { campId, data },
            });
          }
          store.dispatch({
            type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
            payload: [{ campaign_id: res.data.campaign_id, name: res.data.campaign_name }],
            newlyAdded: true,
          });

          hide();
        })
        .catch((err) => {
          store.dispatch({
            type: CAMPAIGNS_LIST.CLONE_IN_PROGRESS,
            payload: false,
          });
          hide();
        });
  };
  return (
    <Wrapper
      onClick={() => {
        if (props.onCardClick) props.onCardClick();
      }}
      {...(props.index === 0 ? { id: "campaignCard aa", className: "abc" } : {})}
      // id="campaignCard"
      {...(props.wrapperClass ? { className: props.wrapperClass } : {})}
    >
      <div className="preview">
        <div className="pills">
          {props.campaign && (
            <span>
              <CampaignIcon />
            </span>
          )}
          {props.email && (
            <span>
              <Mail />
            </span>
          )}
          {props.portal && (
            <span>
              <Portal />
            </span>
          )}
          {props.grid && (
            <span>
              <Tiles />
            </span>
          )}
          {/* {props.time && (
            <div className="time">
              <Clock /> {props.time}
            </div>
          )} */}
        </div>
        <div
          className="preview-1"
          style={{
            backgroundImage: `url(
              ${props.imgUrlOne}
            )`,
          }}
        ></div>
        <div
          className="preview-2"
          style={{
            backgroundImage: `url(
              ${props.imgUrlTwo}
            )`,
          }}
        ></div>
        <div
          className="preview-3"
          style={{
            backgroundImage: `url(
              ${props.imgUrlThree}
            )`,
          }}
        ></div>
      </div>
      <div className="details">
        <div className="name">
          {
            <Tooltip placement="top" title={ellipsisState ? props.title : undefined}>
              <Paragraph
                className="paragraph-styling"
                ellipsis={{ rows: 2, onEllipsis: setEllipsistate }}
                data-id="campaigns-name-label"
              >
                <>
                  {props.title?.startsWith("[Cloned]") ? (
                    <>
                      {<text style={{ color: "#1EC252" }}>[Cloned]</text>} {props.title.substring(8)}
                    </>
                  ) : (
                    props.title
                  )}
                </>
              </Paragraph>
            </Tooltip>
          }
          {props?.automation && (
            <div className="workflow">
              <img src={Workflow} alt="" />
            </div>
          )}
        </div>
        <div className="info">
          <span className="type">{`${props.emailsCount} email${props.emailsCount && props.emailsCount > 1 ? "s" : ""
            } `}</span>
          |<span> {`updated ` + props.published}</span>
        </div>
        <div className="actions d-flex justify-content-between">
          <ul
            className="flex-grow-1 d-flex d-flex justify-content-around"
          // style={{ paddingRight: "30px" }}
          >
            <li>
              <a>
                <Audience />
                <span className="qa-total-campaigncard">{props.audience}</span>
              </a>
            </li>
            <li>
              <a>
                <Send />
                <span>{props.send}</span>
              </a>
            </li>
            <li>
              <a>
                <Mail />
                <span>{props.mail}</span>
              </a>
            </li>
            <li>
              <a>
                <Eye />
                <span>{props.views}</span>
              </a>
            </li>
            <li>
              <a>
                <Click />
                <span>{props.clicks}</span>
              </a>
            </li>
            <li className="card-popover">
              <MenuPopup
                cloneCampaignHandler={cloneCampaignHandler}
                campaignId={props.campaignId}
                deleteHandler={props.deleteHandler}
                showDeleteConfirmation={props.showDeleteConfirmation}
                index={props.index}
                data={props}
                disableDelete={props.automation}
              >
                <div>
                  <Elipsis className="card-popover-inner" />
                </div>
              </MenuPopup>
            </li>
          </ul>
        </div>
      </div>
    </Wrapper>
  );
};

export default CampaignCard;

const Wrapper = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  margin-bottom: 50px;
  height: calc(100% - 50px);
  cursor: pointer;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 7px;
    margin-bottom: 35px;
  }
  .preview {
    position: relative;
    .pills {
      position: absolute;
      top: 14px;
      left: 12px;
      span,
      a {
        padding: 0 3px;
        float: left;
        svg {
          max-width: 18px;
          max-height: 18px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-width: 13px;
            max-height: 13px;
          }
          path {
            fill: #fff;
          }
        }
      }
      .time {
        border-radius: 10px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.44);
        text-align: center;
        font-size: 10px;
        padding: 1px 7px;
        font-family: "robotobold";
        font-weight: 700;
        float: left;
        margin-top: 4px;
      }
    }
    .preview-1 {
      width: 70%;
      height: 136px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-right: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 96px;
      }
    }
    .preview-2 {
      width: 30%;
      height: 67px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-bottom: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 48px;
      }
    }
    .preview-3 {
      width: 30%;
      height: 69px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 48px;
      }
    }
  }
  .details {
    padding: 14px 19px 10px 19px;
    background-color: #ffffff;
    float: left;
    width: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 9px 13px 10px 13px;
    }
    .name {
      color: #424b50;
      font-size: 22px;
      line-height: 28px;
      font-weight: 600;
      font-family: "Roboto Slab", serif;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 10px;
      width: 100%;
      min-height: 56px;
      -webkit-box-align: start;
      /* display: flex;
      align-items: center;
      justify-content: space-between; */
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 16px;
        line-height: 18px;
        height: 36px;
        min-height: 36px;
      }
    }
    .workflow {
      float: right;
      top: 0;
      position: absolute;
      right: 0;
    }
    .paragraph-styling {
      margin-bottom: 0;
      overflow-wrap: normal;
      word-break: break-word;
      width: calc(100% - 23px);
    }
    .info {
      color: #7e7e7e;
      font-size: 12px;
      font-family: "robotomedium";
      margin-bottom: 13px;
      clear: both;
      width: 100%;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
        margin-bottom: 9px;
      }
      .type {
        color: #db3725;
      }
    }
    .actions {
      ul {
        list-style: none;
        margin: 0 -10px;
        padding: 0;
        li {
          float: left;
          display: inline-block;
          padding: 0 3px;
          @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            padding: 0;
          }
          a {
            padding: 0px;
            text-align: center;
            display: block;
            // @media all and (max-width: 1300px) {
            //   padding: 0 3px;
            // }
            svg {
              width: 18px;
              max-height: 12px;
              @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                max-height: 9px;
                width: auto;
              }
              path {
                fill: #000000;
                opacity: 0.5;
              }
              g {
                opacity: 1;
              }
            }

            span {
              color: #5e7079;
              font-size: 10px;
              font-family: "helveticaneuebold";
              font-weight: 700;
              display: block;
              text-align: center;
              @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                font-size: 7px;
              }
            }
          }
          &.card-popover {
            float: right;
            div {
              padding: 10px;
              svg {
                width: 5px;
                max-height: none;
                @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                  width: 3px;
                }
              }
            }
          }
          &:hover {
            a {
              svg path {
                fill: #27ce0a;
              }
            }
          }
        }
      }
    }
  }
`;
